import { fetchAPI } from "@/api/api"

const FINGERPRINT_PRO_PUBLIC_KEY_API_URL =
  "/exchange/member/playerService/getFingerprintProPublicKey"

export interface FingerprintProPublicKeyData {
  publicKey: string
  createdDate: number
  siteId: number
  status: string
  userId: string
  status_msg: "Success" | "Fail"
  // Backend-controlled switch (SACRIC-1262): true routes Fingerprint traffic
  // through our proxy endpoint; false lets the agent use its native default
  // Fingerprint hosts. Absent during rollout is treated as false (proxy off).
  proxyEnabled: boolean
}

const fetch = {
  url: FINGERPRINT_PRO_PUBLIC_KEY_API_URL,
  handler: async (): Promise<FingerprintProPublicKeyData | undefined> => {
    const res: FingerprintProPublicKeyData = await fetchAPI({
      url: FINGERPRINT_PRO_PUBLIC_KEY_API_URL,
      method: "get"
    })

    if (res?.status_msg !== "Success") {
      console.warn("[getFingerprintProPublicKey] API returned non-success status", res)
      return undefined
    }

    return res
  }
}

export default fetch
